'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import tkns from '@lualtek/tokens/web/tokens.json';
import { Fragment, useCallback, useId, useMemo, } from 'react';
import styles from './skeleton.module.css';
export const Skeleton = ({ className, children, radius = 4, style, width, height, count = 1, gap, enableAnimation = true, inline, circle, loading, ...otherProps }) => {
    const uid = useId();
    const computedWidth = useMemo(() => (typeof width === 'number' ? `${width}px` : width), [width]);
    const computedHeight = useMemo(() => (typeof height === 'number' ? `${height}px` : height), [height]);
    const dynamicStyle = useMemo(() => ({
        '--radius': radius && tkns.radius[radius],
        '--width': width && computedWidth,
        '--height': height && computedHeight,
        '--gap': gap ? tkns.space[gap] : undefined,
    }), [radius, width, computedWidth, height, computedHeight, gap]);
    const SkeletonItem = useCallback(() => (_jsx("span", { className: styles.SkeletonItem, "data-skeleton-circle": circle, "data-skeleton-animated": enableAnimation, style: { ...dynamicStyle, ...style }, children: "\u200C" })), [circle, enableAnimation, dynamicStyle, style]);
    return (_jsx("span", { className: className, "aria-live": "polite", "aria-busy": enableAnimation, ...otherProps, children: !children
            ? Array.from(Array(count).keys()).map(n => (inline
                ? _jsx(SkeletonItem, {}, `${uid}-${n}`)
                : (_jsxs(Fragment, { children: [_jsx(SkeletonItem, {}), _jsx("br", {})] }, `${uid}-${n}`))))
            /**
             * If children are provided we hide them and show the skeleton instead
             * while the loading state is active
             */
            : (_jsx(_Fragment, { children: loading ? (_jsx("div", { className: styles.SkeletonItem, "data-skeleton-circle": circle, "data-skeleton-animated": enableAnimation, "data-skeleton-children": Boolean(children), "data-skeleton-inline": inline, style: { ...dynamicStyle, ...style }, children: children })) : children })) }));
};
